import React, { useState } from 'react';
import {
  Box,
  Button,
  TextField,
  Typography,
  CircularProgress
} from '@material-ui/core';
import { validateProfileData } from '../../utils/phoneValidation';
import { REPLAY_MASK } from "../../utils/replay-mask";

const ProfileComplete = ({ onCompleteProfile, loading, error }) => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [validationErrors, setValidationErrors] = useState({});

  const handleSubmit = (e) => {
    e.preventDefault();

    // Validate
    const validation = validateProfileData(name, email);

    if (!validation.isValid) {
      setValidationErrors(validation.errors);
      return;
    }

    setValidationErrors({});

    // Submit profile data
    onCompleteProfile({
      name: name.trim(),
      email: email.trim()
    });
  };

  const handleNameChange = (e) => {
    setName(e.target.value);
    if (validationErrors.name) {
      setValidationErrors({ ...validationErrors, name: null });
    }
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    if (validationErrors.email) {
      setValidationErrors({ ...validationErrors, email: null });
    }
  };

  return (
    <Box className="profile-complete-form">
      <Box className="profile-header" style={{ marginBottom: '25px', textAlign: 'center' }}>
        <Typography variant="h5" style={{ marginBottom: '10px', fontWeight: 600 }}>
          Complete Your Profile
        </Typography>
        <Typography variant="body2" style={{ color: '#666' }}>
          Please provide your name and email to get started
        </Typography>
      </Box>

      <form onSubmit={handleSubmit} noValidate>
        <TextField
          fullWidth
          variant="outlined"
          label="Your Name"
          value={name}
          onChange={handleNameChange}
          placeholder="John Doe"
          required
          error={!!validationErrors.name}
          helperText={validationErrors.name}
          // Helper and error text can echo what was typed (review B2).
          FormHelperTextProps={{ ...REPLAY_MASK }}
          style={{ marginBottom: '20px' }}
          inputProps={{
            maxLength: 50,
            enterKeyHint: 'go'
          }}
        />

        <TextField
          fullWidth
          variant="outlined"
          label="Email"
          inputProps={{ enterKeyHint: 'go' }}
          type="email"
          value={email}
          onChange={handleEmailChange}
          placeholder="john@example.com"
          required
          error={!!validationErrors.email}
          helperText={validationErrors.email}
          FormHelperTextProps={{ ...REPLAY_MASK }}
          style={{ marginBottom: '20px' }}
        />

        {error && (
          <Box className="error-message" {...REPLAY_MASK} style={{ marginBottom: '15px', color: '#d32f2f', fontSize: '14px', textAlign: 'center' }}>
            {error}
          </Box>
        )}

        <Button
          fullWidth
          type="submit"
          variant="contained"
          color="primary"
          disabled={loading || !name.trim() || !email.trim()}
          className="complete-profile-btn"
        >
          {loading ? (
            <>
              Saving <CircularProgress size={20} style={{ marginLeft: '10px', color: '#fff' }} />
            </>
          ) : (
            'Save & Continue'
          )}
        </Button>
      </form>

      <Box style={{ marginTop: '15px', textAlign: 'center', fontSize: '12px', color: '#999' }}>
        By continuing, you agree to our Terms & Privacy Policy
      </Box>
    </Box>
  );
};

export default ProfileComplete;
